<template>
    <div class="table">
        <div class="container">
            <div class="handle-box">
                <el-form :model="queryCondition" :label-position="labelPosition" label-width="100px">
                    <el-row :gutter="16">
                        <el-col :span="6">
                            <el-form-item label="料架名称">
                                <el-input class="handle-input" v-model="queryCondition.mateName" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="总成名称">
                                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="流水号">
                                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-button type="primary" @click="queryData">搜索</el-button>
                            <el-button type="primary">重置</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-row class="action-btn-row">
                <el-button type="primary" @click="downloadMatePart">下载</el-button>
            </el-row>
            <el-table :data="tableData" border highlight-current-row class="table">
                <el-table-column show-overflow-tooltip prop="mateCode" label="料架编号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="no" label="料架名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="mateName" label="流水号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createDate" label="总成序列号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="总成号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="总成名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="更新日期"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="更新人"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination  @current-change="handleCurrentChange" layout="prev, pager, next" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'mate-part',
        data() {
            return {
                tableData: [{
                    mateCode: '123456',
                    no: '00000000',
                    mateName: 'red',
                    createDate: '2019-09-09',
                    status: '9999'
                }],
                total: 0,
                labelPosition: 'right',
                queryCondition:{
                    mateCode: '',
                    status: '',
                    date: '',
                    materialNo: '',
                    materialName: ''
                },
                applyForm: {
                    mateCode: '',
                    mateName: '',
                    applyCount: 0
                },
                applyDialog: false
            }
        },
        methods: {
            queryData(){
                console.dir(this.queryCondition);
            },
            /**
             * 翻页事件
             */
            handleCurrentChange(){

            },
            downloadMatePart(){

            }
        }
    }
</script>
<style scoped>
    .handle-input{
        width: 95%;
    }
    .query-btn-row{
        width: 30%;
        float: right;
    }
    .action-btn-row{
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .dialog-input{
        width: 40%;
    }
</style>